/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import { service } from "@ember/service";
import type { ValidatorMap } from "ember-changeset/types";
import type { IntlService } from "ember-intl";
import CrudJournalEventBaseComponent from "parog-web/components/forc/abstract/crud-journal-event-based-component";
import JournalEventRetrievalStrategies from "parog-web/components/forc/utils/journal-event-retrieval-strategies";
import TemperatureMeasuredJournalEvent from "parog-web/models/temperature-measured-journal-event";
import type SemeiaSessionService from "parog-web/services/session";
import formatNumberAsString from "parog-web/utils/format-number-as-string";

export default class TemperatureEditionFormComponent extends CrudJournalEventBaseComponent<TemperatureMeasuredJournalEvent> {
  @service declare session: SemeiaSessionService;
  @service declare intl: IntlService;

  static forcDisplayName = "Mesure de la température";
  static fullComponentId = "temperature/edition-form";

  get validations(): ValidatorMap {
    return this.journalEventClass.validations(this.intl);
  }

  static journalEventClass = TemperatureMeasuredJournalEvent;
  retrieveJournalEvent = JournalEventRetrievalStrategies.sourceJournalEvent;

  get toastMessage() {
    return this.session.patient
      ? {
          message: "Votre mesure a bien été prise en compte.",
          title: "Température"
        }
      : super.toastMessage;
  }

  @action
  async save(): Promise<void> {
    this.changeset.set(
      "temperature",
      formatNumberAsString(this.changeset.get("temperature"))
    );

    await super.save();
  }
}
